export const AUTH_STORAGE_KEY = "openpath-auth";

export function setStoredAuth(auth) {
  if (typeof window === "undefined") {
    return;
  }
  window.sessionStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(auth));
}

export function getStoredAuth() {
  if (typeof window === "undefined") {
    return null;
  }
  const value = window.sessionStorage.getItem(AUTH_STORAGE_KEY);
  if (!value) {
    return null;
  }
  try {
    return JSON.parse(value);
  } catch {
    window.sessionStorage.removeItem(AUTH_STORAGE_KEY);
    return null;
  }
}

export function clearStoredAuth() {
  if (typeof window === "undefined") {
    return;
  }
  window.sessionStorage.removeItem(AUTH_STORAGE_KEY);
}